import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ClickProvider } from "./context/ClickContext";
import { NotifyProvider } from "./context/NotifyContext";
import { SessionProvider } from "src/context/SessionContext";
import { SocketProvider } from "src/context/SocketContext";
import { DraftProvider } from "./context/DraftContext";
import { SnackbarProvider } from "./context/SnackbarContext";
import "./views/website/i18n";
const queryClient = new QueryClient();



const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <SnackbarProvider>
    <NotifyProvider>
      <ClickProvider>
        <QueryClientProvider client={queryClient}>
          <SessionProvider>
            <SocketProvider>
              <DraftProvider>
                <React.StrictMode>
                  <App />
                </React.StrictMode>
              </DraftProvider>
            </SocketProvider>
          </SessionProvider>
        </QueryClientProvider>
      </ClickProvider>
    </NotifyProvider>
    </SnackbarProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

